import PropTypes from 'prop-types';
import { useFragment, useRelayEnvironment, graphql } from 'react-relay';

// components
import DisplayPromoCode from 'dibs-display-promo-code';

// styles
import styles from './ShippingDetailsPromo.scss';

export const ShippingDetailsPromo = ({ item: itemRef }) => {
    const environment = useRelayEnvironment();
    const item = useFragment(
        graphql`
            fragment ShippingDetailsPromo_item on Item {
                serviceId
            }
        `,
        itemRef
    );

    return (
        <div className={styles.promoWrapper}>
            <DisplayPromoCode
                environment={environment}
                itemId={item?.serviceId}
                showDetails={false}
                promoCodeClass={styles.promoCodeClass}
                onlyShippingPromos
            />
        </div>
    );
};

ShippingDetailsPromo.propTypes = {
    item: PropTypes.object,
};
